module.exports = __webpack_public_path__ + "static/media/r5.fc319281.jpg";